import React, { useEffect, useState } from 'react';
import AppConst from "../apis/appconst";
import axios from "axios";
import SampleModel from '../models/SampleModel';
import { Modal, Button, Form } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import Swal from "sweetalert2";

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

import QRCode from 'qrcode';
import { toast } from 'react-toastify';

import DataTable from 'react-data-table-component';
import JsBarcode from 'jsbarcode';

const LabRegistrations = () => {
  const today = new Date().toISOString().split("T")[0];

  const [selectedUser, setSelectedUser] = useState(null);
  const [image, setImage] = useState('');
  const [watermarkImage, setWatermarkImage] = useState('');
  const [footerImage, setFooterImage] = useState('');
  const [Name, setName] = useState('');
  const [selectedTests, setSelectedTests] = useState([]);
  const [showBarcodeModal, setShowBarcodeModal] = useState(false);

  const [formData, setFormData] = useState({
    cat_type: 'department',
    page_no: 0,
    l1: [],
    departs: [],
    selItem: {},
    search_key: '',
    from: today,
    to: today,
    test_report_datetime: ''
  });

  const [ldata, setLdata] = useState(null);
  const [selItem, setSelItem] = useState(null);

  // init on mount
  useEffect(() => {
    const now = new Date();
    const yyyy = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');
    const todayStr = `${yyyy}-${mm}-${dd}`;
  
    setFormData(prev => ({ ...prev, from: todayStr, to: todayStr }));
    initData({ from: todayStr, to: todayStr });
  
    const storedData = sessionStorage.getItem("ldata");
    if (storedData) {
      try {
        setLdata(JSON.parse(storedData));
      } catch (e) {
        console.warn("Failed to parse ldata", e);
      }
    }
  }, []);

  useEffect(() => {
    if (formData.from && formData.to) {
      initData();
    }
  }, [formData.from, formData.to]);
  
  useEffect(() => {
    const cleanup = () => {
      document.querySelectorAll('.modal-backdrop').forEach(n => n.remove());
      document.body.classList.remove('modal-open');
      document.querySelectorAll('.modal.show').forEach(m => m.classList.remove('show'));
    };

    cleanup();
    window.addEventListener('beforeunload', cleanup);
    return () => {
      window.removeEventListener('beforeunload', cleanup);
      cleanup();
    };
  }, []);
// Add this after your other useEffect hooks, before the columns definition

// ✅ AUTO-REFRESH: Refresh page every 5 minutes if no user activity
useEffect(() => {
  let activityTimer;
  let lastActivityTime = Date.now();
  const INACTIVITY_TIMEOUT = 5 * 60 * 1000; // 5 minutes in milliseconds

  // Function to reset activity timer
  const resetActivityTimer = () => {
    lastActivityTime = Date.now();
    
    // Clear existing timer
    if (activityTimer) {
      clearTimeout(activityTimer);
    }

    // Set new timer
    activityTimer = setTimeout(() => {
      const now = Date.now();
      const timeSinceLastActivity = now - lastActivityTime;

      // If truly inactive for 5 minutes, refresh the page
      if (timeSinceLastActivity >= INACTIVITY_TIMEOUT) {
        console.log("🔄 Auto-refreshing page due to inactivity...");
        
        // Option 1: Refresh entire page (full reload)
        window.location.reload();
        
        // Option 2: Just refresh data (uncomment if you prefer this)
        // const today = new Date().toISOString().split('T')[0];
        // initData({ from: today, to: today, search_key: "" });
      }
    }, INACTIVITY_TIMEOUT);
  };

  // Activity event listeners
  const activityEvents = [
    'mousedown',
    'mousemove', 
    'keypress',
    'scroll',
    'touchstart',
    'click'
  ];

  // Attach listeners
  activityEvents.forEach(event => {
    document.addEventListener(event, resetActivityTimer, true);
  });

  // Start initial timer
  resetActivityTimer();

  // Cleanup
  return () => {
    if (activityTimer) {
      clearTimeout(activityTimer);
    }
    activityEvents.forEach(event => {
      document.removeEventListener(event, resetActivityTimer, true);
    });
  };
}, []);
  const initData2 = async () => {
    const storedDataF = JSON.parse(sessionStorage.getItem("ldata") || "{}");
    setName(
      [storedDataF?.fname, storedDataF?.lname].filter(Boolean).join(" ")
    );
    const storedData = sessionStorage.getItem("ldata");
    if (storedData) {
      try {
        const fd = new FormData();
        fd.append('cat_type', "department");
        fd.append('page_no', "none");
        fd.append('search_key', "");
        fd.append('par_by', "all");

        const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd);
        if (response.data.status && response.data.records) {
          setFormData(prev => ({
            ...prev,
            departs: response.data.records
          }));
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  useEffect(() => {
    initData2();
  }, []);

  const initData = async (overrides = {}) => {
    try {
      const fd = new FormData();

      const from = overrides.from !== undefined ? overrides.from : formData.from;
      const to = overrides.to !== undefined ? overrides.to : formData.to;
      const search_key = overrides.search_key !== undefined ? overrides.search_key : (formData.search_key || "");

      fd.append('page_no', 'none');
      fd.append('search_key', search_key + "");
      fd.append('from', from ? (from + " 00:00:00") : "");
      fd.append('to', to ? (to + " 23:59:59") : "");
      fd.append('lab_reg_user', 'all');

      const response = await axios.post(AppConst.BASE_URL + AppConst.getLabRegListUrl, fd);

      if (response.data && response.data.status) {
        const records = response.data.records || [];
        setFormData(prev => ({ ...prev, l1: records }));
      } else {
        setFormData(prev => ({ ...prev, l1: response.data?.records || [] }));
      }
    } catch (err) {
      console.error("initData error:", err);
      toast.error("Failed to load patient list.");
    }
  };

  useEffect(() => {
    const storedData = sessionStorage.getItem("ldata");
    if (storedData) {
      const parsed = JSON.parse(storedData);
      setLdata(parsed);
    }
  
    const storedLabDt = sessionStorage.getItem("lab_dt");
    if (storedLabDt) {
      try {
        const parsed = JSON.parse(storedLabDt);
        
        (async () => {
          let items = parsed.params || parsed.tests || parsed.all_tests || [];

          if ((!items || items.length === 0) && parsed.lab_reg_id) {
            items = await fetchLabItemsByRegId(parsed.lab_reg_id);
          }

          items = (items || []).map(it => ({
            ...it,
            lab_item_test_name: (it.lab_item_test_name || it.test_name || "").toString()
          }));

          const normalizedRecord = {
            ...parsed,
            tests: items,
            params: items,
            displayTestNames: items.length ? items.map(t => (t.lab_item_test_name || '').trim()).join(' || ') : (parsed.displayTestNames || '')
          };

          setFormData(prev => ({ ...prev, l1: [normalizedRecord] }));
          setSelectedUser(normalizedRecord);
          setSelectedTests((normalizedRecord.tests || normalizedRecord.params || []).map(t =>
            (t.lab_item_test_name || t.test_name || '').toString()
          ));
        })();
  
      } catch (e) {
        console.error("Failed to parse sessionStorage.lab_dt", e);
        initData();
      }
      return;
    }
  
    initData();
  }, []);

  const fetchLabItemsByRegId = async (labRegId) => {
    try {
      const fd = new FormData();
      fd.append('page_no', 'none');
      fd.append('lab_item_parent', String(labRegId));
      const res = await axios.post(AppConst.BASE_URL + AppConst.getLabRegListItmUrl, fd);
      if (res.data && res.data.status && Array.isArray(res.data.records)) return res.data.records;
      return [];
    } catch (err) {
      console.error("fetchLabItemsByRegId error:", err);
      return [];
    }
  };

  function formatDateTime(dtStr) {
    if (!dtStr) return "";
    try {
      let d = new Date(dtStr);
      if (isNaN(d.getTime())) {
        const t = String(dtStr).trim().replace(" ", "T");
        d = new Date(t);
      }
      if (isNaN(d.getTime())) return String(dtStr);

      const dd = String(d.getDate()).padStart(2, "0");
      const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
      const mon = months[d.getMonth()];
      const yyyy = d.getFullYear();

      let hh = d.getHours();
      const ampm = hh >= 12 ? "PM" : "AM";
      hh = hh % 12;
      if (hh === 0) hh = 12;
      const mm = String(d.getMinutes()).padStart(2, "0");

      return `${dd}-${mon}-${yyyy} ${String(hh).padStart(2, "0")}:${mm} ${ampm}`;
    } catch (e) {
      return String(dtStr);
    }
  }

  const collectSamepl = (item) => {
    try {
      setSelItem(item);
      setSelectedUser(item);
  
      const testsArray =
        Array.isArray(item?.params)
          ? item.params
          : Array.isArray(item?.all_tests)
          ? item.all_tests
          : [];
  
      // ✅ EXCLUDE RADIOLOGY
      const nonRadiologyTests = testsArray.filter(t => {
        const dept =
          (t.lab_item_department ||
           t.department ||
           t.cat_type ||
           '').toString().toLowerCase();
  
        return !dept.includes('radiology');
      });
  
      // Show barcode modal instead of directly printing
      setShowBarcodeModal(true);
  
    } catch (err) {
      console.error("collectSamepl error:", err);
    }
  };
  

  // Thermal printer barcode function optimized for TSC TE-203 (203 DPI)
  // Thermal printer barcode function optimized for TSC TE-203 (203 DPI)

// Thermal printer barcode function optimized for TSC TE-203 (203 DPI)
const printThermalBarcodes = () => {
  try {
    if (!selItem) {
      toast.error("No patient selected!");
      return;
    }

    const patientName = `${selItem.lab_reg_name_title || ''} ${selItem.lab_reg_name || ''}`.trim();
    const patientUHID = selItem.lab_reg_uhid || '';
    const patientAge = `${selItem.lab_reg_age_year || 0}Y/${selItem.lab_reg_gender || ''}`;
    const regNo = selItem.lab_reg_id || '';

    // Get test count excluding radiology
    const testsArray = Array.isArray(selItem?.params) ? selItem.params : Array.isArray(selItem?.all_tests) ? selItem.all_tests : [];
    const nonRadiologyTests = testsArray.filter(t => {
      const dept = (t.lab_item_department || t.department || t.cat_type || '').toString().toLowerCase();
      return !dept.includes('radiology');
    });
    const barcodeCount = nonRadiologyTests.length > 0 ? nonRadiologyTests.length : 1;
    
    // Generate barcode items HTML (2 column layout)
    let barcodeItemsHTML = '';
    for (let i = 0; i < barcodeCount; i++) {
      barcodeItemsHTML += `
        <div class="barcode-item">
          <canvas id="barcode${i + 1}"></canvas>
          <div class="patient-info">
            <div class="patient-name">${patientName} ${patientAge}</div>
          </div>
        </div>
      `;
    }

    // Generate barcode script - SLIGHTLY INCREASED HEIGHT
    let barcodeScript = '';
    for (let i = 0; i < barcodeCount; i++) {
      barcodeScript += `
        JsBarcode("#barcode${i + 1}", "${patientUHID}", {
          format: "CODE128",
          width: 3,
          height: 42,
          displayValue: true,
          fontSize: 32,
          margin: 8,
          fontOptions: "bold"
        });
      `;
    }

    // Create print window - optimized for TSC TE-203 thermal printer
    const printWindow = window.open('', '_blank', 'width=302,height=600');
    
    const htmlContent = `
<!DOCTYPE html>
<html>
<head>
<title>Barcode Print</title>
<style>
@page {
  size: 80mm auto;
  margin: 0;
}
body {
  width: 80mm;
  font-family: Arial, sans-serif;
  padding: 2mm;
  margin: 0;
}
.barcode-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 3mm;
  row-gap: 3mm;
}

.barcode-item {
  width: 100%;
  border: 1px solid #000;
  padding: 2mm;
  text-align: center;
  box-sizing: border-box;
  page-break-inside: avoid;
}

.patient-info {
  font-size: 10px;
  margin-top: 0mm;
  line-height: 1.2;
}
.patient-name {
  font-weight: bold;
  font-size: 11px;
}
canvas {
  max-width: 100%;
  height: auto;
}
</style>
</head>
<body>
  <div class="barcode-container">
    ${barcodeItemsHTML}
  </div>

  <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.5/dist/JsBarcode.all.min.js"></script>
  <script>
    window.onload = function () {
      ${barcodeScript}
      setTimeout(() => window.print(), 500);
    };
  </script>
</body>
</html>
`;

    printWindow.document.write(htmlContent);
    printWindow.document.close();

    // Close barcode modal after printing
    setShowBarcodeModal(false);

  } catch (error) {
    console.error("Print thermal barcodes error:", error);
    toast.error("Failed to print barcodes");
  }
};

  const onUpNow1 = async (id, sample_type, sample_qty, cont_type, sample_cndi) => {
    try {
      if (!selItem) return;

      const fd = new FormData();
      fd.append('lab_reg_id', String(id));
      fd.append('sample_type', String(sample_type));
      fd.append('sample_qty', String(sample_qty));
      fd.append('cont_type', String(cont_type));
      fd.append('sample_cndi', String(sample_cndi));

      try {
        const response = await axios.post(AppConst.BASE_URL + AppConst.upSampleUrl, fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        if (response.data.status) {
          setSelItem(null);

          setFormData(prev => {
            const newL1 = (prev.l1 || []).map(x => {
              if (String(x.lab_reg_id) === String(id)) {
                return { ...x, lab_reg_status: 'Sample Collected' };
              }
              return x;
            });
            return { ...prev, l1: newL1 };
          });

          Swal.fire({
            title: "Success!",
            text: "Sample collected successfully.",
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
          });
        } else {
          toast.error(response.data?.message || "Failed to update sample");
        }
      } catch (error) {
        console.error("Server error updating sample:", error);
        toast.error("Server error while updating sample");
      }
    } catch (error) {
      console.error("onUpNow1 error:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const filteredList = formData.search_key.trim() === ""
    ? formData.l1
    : (formData.l1 || []).filter(item =>
      (`${item.lab_reg_uhid}`.toLowerCase().includes(formData.search_key.toLowerCase()) ||
        `${item.lab_reg_id}`.toLowerCase().includes(formData.search_key.toLowerCase()) ||
        `${item.lab_reg_name}`.toLowerCase().includes(formData.search_key.toLowerCase()))
    );

  const groupedData = React.useMemo(() => {
    const data = filteredList || [];
    if (data.length === 0) return [];

    if (data[0].tests && Array.isArray(data[0].tests)) {
      return data.map(patient => {
        const { tests, ...restOfPatient } = patient;
        return {
          ...restOfPatient,
          params: tests,
          displayTestNames: tests.map(test => test.lab_item_test_name.trim()).join(' || ')
        };
      });
    } else {
      const grouped = Object.values(data.reduce((acc, testItem) => {
        const key = testItem.lab_reg_id;
        if (!acc[key]) {
          acc[key] = { ...testItem, all_tests: [] };
        }
        acc[key].all_tests.push(testItem);
        return acc;
      }, {}));

      return grouped.map(patient => ({
        ...patient,
        params: patient.all_tests,
        displayTestNames: patient.all_tests.map(t => t.lab_item_test_name.trim()).join(' || ')
      }));
    }
  }, [filteredList]);

  const columns = [
    {
      name: 'SR',
      selector: (row, i) => groupedData.indexOf(row) + 1,
      width: '60px'
    },
    { name: 'UHID No', selector: row => row.lab_reg_uhid || '-', sortable: true, wrap: true, width: '120px' },
    { name: 'Reg No', selector: row => row.lab_reg_id || '-', sortable: true, wrap: true, width: '100px' },
    {
      name: 'Patient Details',
      selector: row => `${row.lab_reg_name_title || ''} ${row.lab_reg_name || ''}`,
      cell: row => (
        <div>
          <div>{row.lab_reg_name_title} {row.lab_reg_name}</div>
          <small>
            <strong>Age:</strong> {row.lab_reg_age_year}y {row.lab_reg_age_month}m {row.lab_reg_age_day}d<br />
            <strong>Gender:</strong> {row.lab_reg_gender}<br />
            <strong>Mobile:</strong> {row.lab_reg_mobile}
          </small>
        </div>
      ),
      sortable: true,
      grow: 1.4,
      wrap: true,
      width: '200px'
    },
    { name: 'Refered Doctor', selector: row => row.lab_reg_referral || '-', sortable: true, wrap: true, width: '140px' },
    { name: 'Test Details', selector: row => row.displayTestNames || 'N/A', wrap: true, grow: 3, width: '200px' },
    {
      name: 'Status',
      selector: row => row.lab_reg_status,
      cell: row => {
        const status = (row.lab_reg_status || '').toString().trim().toLowerCase();
    
        return (
          <div style={{ textAlign: 'center' }}>
            {status === "pending" && (
              <div>
                <i className="ri-flask-fill" style={{ color: "red", fontSize: "24px" }}></i>
                <div style={{ marginTop: 6 }}>
                  <button
                    type="button"
                    className="btn btn-success btn-sm"
                    onClick={() => collectSamepl(row)}
                  >
                    Collect Sample
                  </button>
                </div>
              </div>
            )}
    
            {status === "sample collected" && (
              <i className="bi bi-droplet-half" style={{ color: "green", fontSize: "24px" }}></i>
            )}
    
            {status === "completed" && (
              <i className="ri-check-double-line" style={{ color: "blue", fontSize: "24px" }}></i>
            )}
          </div>
        );
      },
      center: true,
      width: '190px'
    },
    {
      name: 'Patient Type',
      selector: row => row.lab_reg_type,
      center: true,
      width: '130px',
      cell: row => {
        const raw = (row.lab_reg_type || '').toString().trim().toLowerCase();
        let badgeClass = 'badge bg-secondary';
        let label = row.lab_reg_type || 'N/A';
    
        switch (raw) {
          case 'opd':
          case 'outpatient':
            badgeClass = 'badge bg-info text-dark';
            label = 'OPD';
            break;
          case 'ipd':
          case 'inpatient':
            badgeClass = 'badge bg-primary';
            label = 'IPD';
            break;
          case 'emergency':
          case 'er':
          case 'casualty':
            badgeClass = 'badge bg-danger';
            label = 'Emergency';
            break;
          case 'corporate':
            badgeClass = 'badge bg-success';
            label = 'Corporate';
            break;
          case 'referral':
            badgeClass = 'badge bg-warning text-dark';
            label = 'Referral';
            break;
          default:
            label = (row.lab_reg_type || 'Other').toString().replace(/\w\S*/g, w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
            badgeClass = 'badge bg-secondary';
        }
    
        return (
          <div style={{ textAlign: 'center' }}>
            <span className={badgeClass} style={{ padding: '6px 10px', fontSize: '0.95rem' }}>
              {label}
            </span>
          </div>
        );
      }
    },
    { name: 'Registration Datetime', selector: row => formatDateTime(row.lab_reg_datetime) || '-', wrap: true, width: '200px' },
  ];

  // Calculate barcode count for display
  const getBarcodeCount = () => {
    if (!selItem) return 0;
    const testsArray = Array.isArray(selItem?.params) ? selItem.params : Array.isArray(selItem?.all_tests) ? selItem.all_tests : [];
    const nonRadiologyTests = testsArray.filter(t => {
      const dept = (t.lab_item_department || t.department || t.cat_type || '').toString().toLowerCase();
      return !dept.includes('radiology');
    });
    return nonRadiologyTests.length > 0 ? nonRadiologyTests.length : 1;
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card" id="orderList">
              <div className="card-header border-0">
                <div className="row align-items-center gy-3">
                  <div className="col-sm">
                    <h2 className="card-title mb-0" style={{ color: "#405189" }}>Lab Patient Details</h2>
                  </div>
                </div>
              </div>

              <div className="card-body border border-dashed border-end-0 border-start-0">
                <form>
                  <div className="row g-3">
                    <div className="col-md-2">
                      <label className="form-label">From</label>
                      <input className="form-control" type="date" name="from" onChange={handleChange} value={formData.from} />
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">To</label>
                      <input className="form-control" type="date" name="to" onChange={handleChange} value={formData.to} />
                    </div>
                    <div className="col-md-2">
                      <label className="form-label"></label>
                      <div className="search-box" style={{ display: "flex" }}>
                        <button type="button" onClick={() => {
                          const today = new Date();
                          const yyyy = today.getFullYear();
                          const mm = String(today.getMonth() + 1).padStart(2, '0');
                          const dd = String(today.getDate()).padStart(2, '0');
                          const todayStr = `${yyyy}-${mm}-${dd}`;
                          setFormData(prev => ({ ...prev, search_key: "", from: todayStr, to: todayStr, page_no: 0 }));
                          initData({ from: todayStr, to: todayStr, search_key: "" });
                        }} className="btn btn-info">Clear</button>
                      </div>
                    </div>
                    <div className="col-md-3"></div>
                    <div className="col-md-3" style={{ textAlign: "right" }}>
                      <label className="form-label"></label>
                      <div className="search-box">
                        <input className="form-control search" placeholder="Search..." type="text"
                          name="search_key" onChange={handleChange} value={formData.search_key} />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <br />

              <div className="card-body pt-0">
                <div className="table-responsive table-card mb-1">
                  <DataTable
                    columns={columns}
                    data={groupedData || []}
                    pagination
                    highlightOnHover
                    pointerOnHover
                    responsive
                    dense={false}
                    noHeader
                    paginationPerPage={10}
                    striped
                    conditionalRowStyles={[
                      {
                        when: row => row.lab_reg_status === "Sample Collected",
                        style: { backgroundColor: '#e3f9e5' }
                      }
                    ]}
                    customStyles={{
                      rows: {
                        style: {
                          minHeight: '58px',
                          fontSize: '16px'
                        }
                      },
                      headCells: {
                        style: {
                          backgroundColor: '#f1f5fb',
                          color: '#405189',
                          fontSize: '15px',
                          fontWeight: '700',
                          paddingLeft: '14px',
                          paddingRight: '14px',
                        }
                      },
                      cells: {
                        style: {
                          paddingLeft: '14px',
                          paddingRight: '14px',
                          fontSize: '15px',
                          lineHeight: '20px'
                        }
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Sample Collection Modal */}
      <SampleModel
        item={selItem}
        onUpNow={onUpNow1}
        show={!!selItem && !showBarcodeModal}
        onHide={() => {
          setSelItem(null);
        }}
        onCollected={(id) => {
          setFormData(prev => {
            const newL1 = (prev.l1 || []).map(x => {
              if (String(x.lab_reg_id) === String(id)) {
                return { ...x, lab_reg_status: 'Sample Collected' };
              }
              return x;
            });
            return { ...prev, l1: newL1 };
          });
          setSelItem(null);
        }}
      />

      {/* Barcode Print Modal */}
      {/* Barcode Print Modal */}
<Modal show={showBarcodeModal} onHide={() => {
  setShowBarcodeModal(false);
  // Don't set selItem to null - keep it so sample modal can show
}} centered size="md">
  <Modal.Header closeButton>
    <Modal.Title>Barcode Print - with 2 Columns</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <div className="mb-4 p-3 bg-light rounded">
      <h6 className="mb-3 text-primary">Patient Information</h6>
      <div className="row">
        <div className="col-6">
          <p className="mb-2"><strong>Name:</strong><br/>{selItem?.lab_reg_name || 'N/A'}</p>
          <p className="mb-2"><strong>UHID:</strong> {selItem?.lab_reg_uhid || 'N/A'}</p>
        </div>
        <div className="col-6">
          <p className="mb-2"><strong>Reg:</strong> {selItem?.lab_reg_id || 'N/A'}</p>
          <p className="mb-2"><strong>Age/Gender:</strong> {selItem?.lab_reg_age_year || 0}Y/{selItem?.lab_reg_gender || 'N/A'}</p>
        </div>
      </div>
    </div>

    <div className="alert alert-info">
      <i className="ri-information-line me-2"></i>
      <strong>Print Settings:</strong>
      <ul className="mb-0 mt-2">
        <li>Printer: TSC TE-203 (203 DPI)</li>
        <li>Paper Width: 80mm (3 inch)</li>
        <li>Layout: 2 Column</li>
        <li>Barcode Copies: {getBarcodeCount()} (Auto-calculated)</li>
      </ul>
    </div>

  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => {
      setShowBarcodeModal(false);
      // Don't set selItem to null - just close barcode modal
    }}>
      Cancel
    </Button>
    <Button 
      variant="primary" 
      onClick={printThermalBarcodes}
    >
      <i className="ri-printer-line me-2"></i>
      Print Thermal Barcode
    </Button>
  </Modal.Footer>
</Modal>

    </div>
  );
};

export default LabRegistrations;